import { useEffect, useState } from 'react';

/** Relógio da tela: o que é "próxima" ou "já passou" é decidido aqui. */
export default function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
